import { useTranslation } from '@/contexts/i18n-context';
import { useBranding } from '@/outlets/branding-outlet';
import { useEncounter } from '@/contexts/encounter-context';
import { useGetProvider } from '@/api/get-provider-info';
import { ProviderImage } from '@/components/encounter/provider/provider-image';
import { useMediaQuery } from '@/hooks/use-media-query';
import clsx from 'clsx';
import styles from './payment-humanization-banner.module.css';

const translationBase = 'visit.payment.success.humanization';

export function PaymentHumanizationBanner() {
  const { t } = useTranslation();
  const { humanizationTheme } = useBranding();
  const { encounter } = useEncounter();
  const isMobile = useMediaQuery('--screen-md');

  const preferredProviderId = encounter.preferredProviderId;
  const { data: providerData, isPending: isProviderPending } = useGetProvider(
    preferredProviderId ?? '',
    { encounterId: encounter.id },
    { query: { enabled: !!preferredProviderId } },
  );

  if (!humanizationTheme || (!!preferredProviderId && isProviderPending)) {
    return null;
  }

  const provider = providerData?.provider;
  const showProviderVariant = !!provider;

  const title = showProviderVariant
    ? t(`${translationBase}.messageFromProvider`, { providerName: provider.fullName })
    : t(`${translationBase}.messageFromTeam`);
  const thanksLine = t(`${translationBase}.thanksLine`);
  const body = showProviderVariant
    ? t(`${translationBase}.providerBody`)
    : t(`${translationBase}.teamBody`);

  return (
    <div className={styles.banner}>
      {showProviderVariant ? (
        <ProviderImage url={provider.img} className={styles.image} />
      ) : (
        <img
          src={`/humanization/${humanizationTheme}/doc-team-member.png`}
          alt={t(`${translationBase}.teamMemberAlt`)}
          className={clsx(styles.image, styles.teamImage)}
        />
      )}
      <p className={clsx(styles.title, 'bold', !isMobile && 'body-1')}>{title}</p>
      <p className={clsx(styles.thanks, 'semibold', 'italic')}>{thanksLine}</p>
      <p className={clsx(styles.body, 'semibold', 'italic')}>{body}</p>
    </div>
  );
}
